// extracted by mini-css-extract-plugin
export default {"container":"styles_container__l7+3Q","label":"styles_label__TYoM4","icon":"styles_icon__ttOu8"};